import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, bindingMode } from "aurelia-framework";
import { InvoiceBadge } from 'components/badge/invoice-badge';
import { Models } from "models/core";
import { ErrorService } from "services/error-service";
import { ServiceConsumptionSewingThreadService } from 'services/service-consumption-sewing-thread-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class SewingThreadList {
  @bindable private service: Models.Service;
  @bindable private net: Models.Net;
  @bindable private locked;
  @bindable private invoiceConsumptionSewingThreadsStatus: string;
  
  @bindable ({ defaultBindingMode: bindingMode.fromView }) private editFormVisible;
  @bindable ({ defaultBindingMode: bindingMode.fromView }) private newFormVisible;

  private sewingThreads: Array<Models.ServiceConsumptionSewingThread>;
  private originals: any = {};

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private toastService: ToastService,
    private serviceConsumptionSewingThreadService: ServiceConsumptionSewingThreadService
  ) { }

  private attached() {
    this.getConsumptionSewingThreads();

    this.eventAggregator.subscribe('serviceConsumptionSewingThreadsListReset', (value) => {
      this.getConsumptionSewingThreads();
    });

    this.eventAggregator.subscribe('serviceConsumptionSewingThreadsListCancel', (value) => {
      this.sewingThreads = JSON.parse(JSON.stringify(this.originals.sewingThreads));
    });
  }

  private getConsumptionSewingThreads() {
    this.serviceConsumptionSewingThreadService
    .getAll('?$filter=ServiceId eq ' + this.service.Id + ' &$expand=SewingThreadTypeService($expand=Product),LocationCode')
    .then((res) => {
      this.sewingThreads = res;
      this.originals.sewingThreads = JSON.parse(JSON.stringify(res));
      const invoiceConsumptionSewingThreadsStatusList = this.sewingThreads.map((x) => x.ServiceInvoiceId ? true : false);
      this.invoiceConsumptionSewingThreadsStatus = InvoiceBadge.GetInvoiceType(invoiceConsumptionSewingThreadsStatusList);
    })
    .catch((err) => this.errorService.handleError(err));
  }

  private deleteConsumptionSewingThread(consumptionSewingThread: Models.ServiceConsumptionSewingThread) {
    this.serviceConsumptionSewingThreadService
    .delete(consumptionSewingThread.Id)
    .then(() => {
      this.eventAggregator.publish('serviceConsumptionSewingThreadsListReset', 0);
      this.toastService.showSuccess('service.materialConsumptionSewingThreadDeleted');
    })
    .catch((err) => this.errorService.handleError(err));
  }
}